import axios from "axios";
import constants from "../constants/constants";

const {
  GET_TOKENS, GET_TOKENS_SUCCESS, GET_TOKENS_ERROR,
} = constants;

const GET_GD_TOKENS_API_END_POINT = process.env.REACT_APP_API_URL + "/api/user/getTokens";

export const getTokensAction = (config) => async (dispatch) => {
  dispatch({ type: GET_TOKENS })
  await axios.get(GET_GD_TOKENS_API_END_POINT, config)
    .then((res) => dispatch({ type: GET_TOKENS_SUCCESS, gdTokens: res?.data?.gdTokens }))
    .catch((error) => dispatch({ type: GET_TOKENS_ERROR, error }))
}
